module.exports = __webpack_public_path__ + "static/media/marilyn-face.e3427aa5.png";